// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"d4878a0a8ed6f3a0","888":"e2fc86fdb2f725d3"}[chunkId] + ".css";
};